import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const farmerSlice = createSlice({
  name: 'farmer',
  initialState: [],
  reducers: {
    farmerReducer: {
      reducer: (state, action) => (state = action.payload),
      prepare: (value) => ({ payload: value || [] }),
    },
  },
});

export const { farmerReducer } = farmerSlice.actions;
export default farmerSlice.reducer;